//Current maintenance windows are defined in UTC time.
// The start and end times are represented as Unix timestamps in milliseconds. Each maintenance window is an object with 'start' and 'end' properties, indicating the beginning and end of the maintenance period respectively.
export const maintenanceWindows = [
  // /**
  //  * TEST WINDOW FOR 27/08/2026 10:00 - 10:30 UTC (11:00-11:30 BST)
  //  *
  //  */
  // { start: 1787824800000, end: 1787826600000 },
  // //  __________________________
  // // start:2026-09-05T22:30:00.000Z
  // // end:2026-09-07T11:00:00.000Z
  // { start: 1788647400000, end: 1788778800000 },
  // // start:2026-09-12T22:30:00.000Z
  // // end:2026-09-14T11:00:00.000Z
  // { start: 1789252200000, end: 1789383600000 },
  // // start:2026-09-19T22:30:00.000Z
  // // end:2026-09-21T11:00:00.000Z
  // { start: 1789857000000, end: 1789988400000 },
  // // start:2026-09-26T22:30:00.000Z
  // // end:2026-09-28T11:00:00.000Z
  // { start: 1790461800000, end: 1790593200000 },
  // // start:2026-10-03T22:30:00.000Z
  // // end:2026-10-05T11:00:00.000Z
  // { start: 1791066600000, end: 1791198000000 },
  // // start:2026-10-10T22:30:00.000Z
  // // end:2026-10-12T11:00:00.000Z
  // { start: 1791671400000, end: 1791802800000 },
  // // start:2026-10-17T22:30:00.000Z
  // // end:2026-10-19T11:00:00.000Z
  // { start: 1792276200000, end: 1792407600000 },
];
